const state = () => ({
  isSubmissionReview: false,
  contextScope: null
})

const getters = {
  getIsSubmissionReview: (state) => state.isSubmissionReview,
  getContextScope: (state) => state.contextScope
}

const mutations = {
  setIsSubmissionReview(state, value) {
    state.isSubmissionReview = value;
  },
  setContextScope(state, scope) {
    state.contextScope = scope;
  },
  clearLtiState(state) {
    state.isSubmissionReview = false;
    state.contextScope = null;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
